import React from "react";
import ProductList from "./ProductList";

const Products = () => {
  return (
    <div>
      <ProductList />
    </div>
  );
};

export default Products;
